const config = require(`./${process.env.REACT_APP_MOMO_ENV}.js`).default
export default {
    ...config,
}
